import { FC } from 'react';
import classNames from 'classnames';
import { IApartmentResponse } from 'utils/types';
import { ApartmentMap } from './ApartmentMap';
import { SingleApartmentMap } from './SingleApartmentMap';
import styles from './index.module.scss';

export interface ApartmentCardProps {
	data: IApartmentResponse;
	isSingle: boolean;
}

export const ApartmentCard: FC<ApartmentCardProps> = ({ data, isSingle }) => {
	return (
		<div
			className={classNames(styles.address_card, {
				[styles.address_card_single]: isSingle,
				[styles.address_card_inactive]: !data.singleReceipt,
			})}
		>
			{isSingle ? <SingleApartmentMap data={data} /> : <ApartmentMap data={data} />}
		</div>
	);
};
